import { injectable } from "tsyringe";
import { ProvinceConfigurationListRequestEntity } from "../entities/ProvinceConfigurationListRequestEntity";
import { ProvinceConfigurationFormRequestEntity } from "../entities/ProvinceConfigurationFormRequestEntity";
import { ProvinceConfigurationInjection } from "features/provinceConfiguration/di/ProvinceConfigurationInjection";
import { ADDRESS_PATH } from "api/ApiPath";
import { FilterInjection } from "app/filters/di/FilterInjection";
import { BaseAdministrativeRegionModel } from "app/based/baseApiModel/baseAddress/BaseAdministrativeRegionModel";

@injectable()
export class ProvinceConfigurationUseCase {
  private repo = ProvinceConfigurationInjection.getRepo();

  async getRegionList() {
    const filterUseCase = FilterInjection.getUseCase();
    return await filterUseCase.fetchListWithFeature<any, BaseAdministrativeRegionModel>({
      path: ADDRESS_PATH.REGIONS
    });
  }

  private checkParams(params: ProvinceConfigurationListRequestEntity) {
    const { page = 0, limit = 10, ...rest } = params;
    return { page, limit, ...rest };
  }

  async getProvinceConfigurationList(
    params: ProvinceConfigurationListRequestEntity,
  ) {
    return this.repo.getList(this.checkParams(params));
  }

  async getProvinceConfigurationDetail(id: string) {
    return this.repo.getDetail({ id });
  }

  async createProvinceConfiguration(
    body: ProvinceConfigurationFormRequestEntity,
  ) {
    return this.repo.create(body);
  }

  async updateProvinceConfiguration(
    body: ProvinceConfigurationFormRequestEntity,
  ) {
    return this.repo.update(body);
  }

  async deleteProvinceConfiguration(id: string) {
    return this.repo.delete({ id });
  }
}
